var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center text-secondary-red justify-center"},[_vm._t("default",function(){return [_c('MIcon',{staticClass:"mr-2",attrs:{"name":"exclamation-triangle","size":"lg"}}),_c('div',{staticClass:"text-secondary-red"},[_vm._v(" No Item Selected! this page needs to be designed ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }